import type { ReactNode } from "react";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import CustomKeyboardAvoidingView from "../../CustomKeyboardAvoidingView";
import { MOBILE_CONTENT_BOTTOM_PADDING } from "./item-types/constants";

const PassageStemSection = ({ children }: { children: ReactNode }) => {
	const theme = useAppTheme();
	return (
		<Box backgroundColor={theme.colors.surface} marginBottom={16}>
			{children}
		</Box>
	);
};

const QuestionSection = ({
	children,
	contentBottomPadding = 0,
}: {
	children: ReactNode;
	contentBottomPadding?: number;
}) => {
	const theme = useAppTheme();
	return (
		<Box flex={1} backgroundColor={theme.colors.background}>
			<CustomKeyboardAvoidingView
				showsVerticalScrollIndicator={false}
				style={{ flex: 1 }}
				contentContainerStyle={{
					flexGrow: 1,
					gap: 16,
					paddingBottom: contentBottomPadding,
				}}
			>
				{children}
			</CustomKeyboardAvoidingView>
		</Box>
	);
};

const MobileItemLayout = ({ children }: { children: ReactNode }) => {
	const theme = useAppTheme();
	return (
		<Box
			flex={1}
			backgroundColor={theme.colors.background}
			paddingBottom={MOBILE_CONTENT_BOTTOM_PADDING}
		>
			{children}
		</Box>
	);
};

MobileItemLayout.PassageStemSection = PassageStemSection;
MobileItemLayout.QuestionSection = QuestionSection;

export default MobileItemLayout;
